<div class="search-info mt-3 mb-3 navbar" *ngIf="manage">
  <app-dropdown-menu [options]="options" [selected]="selected" [extraInfo]="getInfo()" (select)="onSelectCompetition($event)"></app-dropdown-menu>
</div>

<div class="header container-fluid clearfix">
  <div class="row">
    <div class="filters col-sm-9 p-0">
      <div class="text-light font-weight-normal" (click)='onShowAll()' [class.selected]='showAll'>
        <img src='{{showAll ? "/assets/img/selected.svg" : "/assets/img/rectangle-4.svg"}}' alt="Show All">
        <span>Show All</span>
      </div>
      <div class="text-light font-weight-normal" (click)='onFilterChange(key)' [class.selected]='filters[key].value' *ngFor='let key of filters.getKeys()'>
        <img src='{{filters[key].value ? "/assets/img/selected.svg" : "/assets/img/rectangle-4.svg"}}' alt='filters[key].title'>
        <span>{{filters[key].title}}</span>
      </div>
    </div>
    <div class="sorting col-sm-3 p-0">
      <app-dropdown-sort class="float-right" (select)="onSorting($event)"></app-dropdown-sort>
    </div>
  </div>
</div>

<div class="tile-container">
  <app-asset-tile *ngFor="let file of files" class="tile" [data]="file"></app-asset-tile>

</div>

<button *ngIf="!!lastEvaluatedKey" type="button" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
  More results<i class="icon icon-arrow-fwd-sm-link"></i>
</button>
